import { render, staticRenderFns } from "./OnePlatformGroupConsent.vue?vue&type=template&id=1097866e&scoped=true&"
import script from "./OnePlatformGroupConsent.vue?vue&type=script&lang=js&"
export * from "./OnePlatformGroupConsent.vue?vue&type=script&lang=js&"
import style0 from "./OnePlatformGroupConsent.vue?vue&type=style&index=0&id=1097866e&prod&lang=css&"
import style1 from "./OnePlatformGroupConsent.vue?vue&type=style&index=1&id=1097866e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1097866e",
  null
  
)

export default component.exports